




















import Vue from "vue";

export default Vue.extend({
  name: "ChangeInvoiceEmail",
  props: {
    settingModel: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        emailAddress: [
          {
            required: true,
            message: "Please enter email address",
            trigger: "change",
          },
          {
            type: "email",
            message: "Should be one email address.",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
  },
  watch: {
    showModal(newVal) {},
  },
  methods: {
    handleCancel() {
      (this.$refs.SetupForm as any).resetFields();
      this.$emit("cancel");
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave(event) {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let dto = {
            emailAddress: this.settingModel.emailAddress,
          };

          let context = this;
          context.$store.dispatch("billing/updateInvoiceEmail", { data: dto }).then(() => {
            context.$Notice.success({
              title: "Change Invoice Email",
              desc: "Success! ",
            });
            context.$emit("cancel");
            target.disabled = false;
            (this.$refs.SetupForm as any).resetFields();
          });
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
